import { render } from "./KarussellMotorrad2.vue?vue&type=template&id=323e5086"
import script from "./KarussellMotorrad2.vue?vue&type=script&lang=js"
export * from "./KarussellMotorrad2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__